module.exports = __webpack_public_path__ + "skill2.png?02cc427e7be388ffed394aacfe264349";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skill2.png
// module id = 57
// module chunks = 0